<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{modalTitle}}</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;" id="FIR_COMMENTS"></i>
    </div>
  </div>
  
  <!-- Modal Body -->
  <div class="modal-body" [hidden]="minimise">
    <div>
      <form name="taxTrueUpComments" id="taxTrueUpComments" novalidate autocomplete="off">
        <div class="comment-row">
          <div class="form-group">
            <label class="col-md-1 control-label">
              <strong>Comments:</strong>
            </label>
            <div class="col-md-6">
              <textarea 
                class="form-control" 
                name="comments" 
                id="FIR_COMMENTS_2"
                [(ngModel)]="COMMENTS" 
                required 
                maxlength="3998"></textarea>
              <div class="textarea_allowed">Max 2000</div>
            </div>
          </div>
        </div>

        <div class="comment-row row-mt-10">
          <div class="col-md-12">
            <table class="table table-bordered custom-table" style="text-align: left; table-layout: fixed;">
              <thead>
                <tr>
                  <th width="70%">Comment</th>
                  <th width="15%">Logged By</th>
                  <th width="15%">Logged On</th>
                </tr>
              </thead>
              <tbody>
                @for (comment of allComments; track $index) {
<tr>
                  <td style="word-wrap: break-word">{{comment.DETAIL_COMMENTS}}</td>
                  <td>{{comment.UPDATED_BY}}</td>
                  <td>{{comment.UPDATED_ON}}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
        
        <div class="comment-row">
          <br>
        </div>
      </form>
    </div>
  </div>
  
  <!-- Modal Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button 
      id="FIR_COMMENTS_3" 
      class="save-button" 
      type="button" 
      (click)="saveComments()">
      @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Save
    </button>
    <button 
      id="FIR_COMMENTS_4" 
      class="cancel-button" 
      type="button"
      (click)="cancel()">Cancel</button>
  </div>
</div>

